
import EoCard from "../../EoCard/EoCard.vue"

export default {
  name: "PreprCardItem",
  components: { EoCard },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model: https://developers.prepr.io/reference#carditem
      dataModel: {
        url: null,
        url_label: null,
        assets: {
          items: [{
            label: null,
            body: null,
            cdn_files: {
              items: [{
                url: null,
              }],
            },
          }],
        },
        body: null,
        sub_title: null,
        description: null,
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
  },
}
